//core modules
import React, {useEffect, useRef, useState} from 'react';

//external modules
import cx from "classnames";
import Switch from "react-switch";
import Select from "react-select";

//custom modules
import {useStepsContext} from "./context/stepsContext";
import {currencyFormatter, getPaymentInfo, handleErrorResponse, setSessionValue, proceeToLink} from "../../Common/Appcommon";
import requestApi from "../../services/requestApi.service";
import { useRadioGroup } from '@mui/material';
import parseHtml from 'html-react-parser';


const UserRow = ({ title, label = "No.of Users", subLabel, value, onChange, disabled, price, showGst = true, hidden = false, inputRef }) => {
    if (hidden) return null;
    return (
        <>
            {title && <div>{title}</div>}
            <div className={`user-count-selection`}>
                <div className={`user-count-label`}>
                    <span>{label}</span><br/>
                    <span className={`unit-price`}>{subLabel}</span>
                </div>
                <div className={`user-count-add`}>
                    <input
                        value={value}
                        onChange={(e)=>onChange(e.target.value)}
                        className={`form-control`}
                        ref={inputRef}
                        disabled={disabled}
                        maxLength={4}
                    />
                </div>
                <div className={`user-count-price-meter`}>
                    <div>{price}</div>
                    {showGst && <div>+18% GST</div>}
                </div>
            </div>
        </>
    );
};

const SubscriptionCustomize = () => {

    const InputRef = useRef(null);
    const [error, setError] = useState('');

    const {
        plan,
        currentStep,
        setCurrentStep,
        paymentInfo,
        requiredUsers,
        setRequiredUser,
        subTotal,
        setSubTotal,
        total,
        setTotal,
        isPricingUpdate,
        isEarlyUpdate,
        paidUsers,
        isPrevPricingSub,
        resetSubscriptionInfo,
        setPreviosPaymentDeduction,
        updateUsageType,
        addRequiredUsers,
        setAddRequiredUsers,
        addSubTotal,
        setAddSubTotal,
        addTotal,
        setAddTotal,
        tax,
        setTax,
        usageType,
        subscriptiontype,
        setUsageType,
        checkCurrentURLIsValid,
        isRecurringPayment,
        addOnsRecord,
        setAddOnsRecord,
        callRec,
        setCallRec,
        whatsappApi,
        setWhatsappApi,
        cloudTele,
        setCloudTele,
        recordsOption,
        callRecOption,
        addOnsRecordVal,
        setAddOnsRecordVal,
        callRecVal,
        setCallRecVal,
        whatsappApiVal,
        setWhatsappApiVal,
        cloudTeleVal,
        setCloudTeleVal,
        addOnsTotal,
        setAddOnsTotal,
        currentBill,
        billingInfo,
        isAddonEnbled,
        oldCallRecVal,
        planMonths,
        paymentDetails,
        offerType,
        setSubscriptionType,
        setIsEMandate
    } = useStepsContext();

    useEffect(()=>{
        if(InputRef && InputRef.current){
            InputRef.current.focus();
        }
        (async () => {
            //const data = await getPaymentInfo();
            // prefill the current pricing details in states.
            let noofusers = parseInt(paymentInfo[18] === "UL" ? paymentInfo[paymentInfo.length - 1] : paymentInfo[18]);

            /* if(usageType !== 4 || isEarlyUpdate || parseInt(noofusers) < parseInt(data[18])){
                noofusers = parseInt(data[18]);
            } */
            if(offerType === "Package"){
                let userscount = parseInt(paymentInfo[4]);
                let nooftotalusers = parseInt(paymentInfo[18]);
                if(userscount < nooftotalusers){
                    userscount = nooftotalusers;
                }
                handleUserCountChange(userscount);
            }else if(requiredUsers === "" || (subscriptiontype === "addonusers" || subscriptiontype === "reduceusers")){
                handleUserCountChange(noofusers);
            }
            checkCurrentURLIsValid();
            if(subscriptiontype === "addonusers"){
                setUsageType(3);
            }else if(subscriptiontype === "reduceusers"){
                setUsageType(4);
            }else{
                updateUsageType();
            }
        })();
    },[]);

    const handleProceed = () => {
        let isvalid = true;

        if((usageType === 3  || usageType === 4) && (addRequiredUsers === '0' || addRequiredUsers === '')){
            setError(`Please fill the Required Additional User Box *`);
            return;
        }

        let minimumUserError = checkMinimumUsers();

        if(minimumUserError){
            //only allow to increase user count for non recurring plan users.
            if(isEarlyUpdate && !isPrevPricingSub && parseInt(requiredUsers) <= parseInt(paidUsers) && !isPricingUpdate){
                isvalid = false;
                setError(`You already have subscription for ${paidUsers} user(s).`);
                return;

            // prevent customer from trying to subscribe for the same user count.
            }else if(isEarlyUpdate && isPrevPricingSub && parseInt(requiredUsers) == parseInt(paidUsers) && !isPricingUpdate){
                isvalid = false;
                setError(`You already have subscription for ${paidUsers} user(s).`);
                return;
            }
            let isLessActiveUsers = parseInt(requiredUsers) < parseInt(paymentInfo[paymentInfo.length - 1]);
            let isaddLessActiveUsers = parseInt(addRequiredUsers) < parseInt(paymentInfo[paymentInfo.length - 1]);
            const isActiveUserError = (
                (isEarlyUpdate && (
                    (usageType === 9 && isLessActiveUsers) || 
                    (usageType === 4 && addRequiredUsers !== "" && isaddLessActiveUsers)
                )) || 
                (([0, 2, 8, 13].includes(usageType)) && isLessActiveUsers)
            );
            
            if (isActiveUserError) {
                const activeUsers = paymentInfo[paymentInfo.length - 1];
                setError(`At the moment, your account has <strong>${activeUsers} Active Users</strong>. Kindly deactivate any users that are not necessary and give it another try.`);
                return;
            }

            if(isEarlyUpdate && usageType === 4 && parseInt(requiredUsers) <= parseInt(addRequiredUsers)){
                isvalid = false;
                setError("Currently, your subscription is already set for <strong>" + paidUsers + " users </strong> only. Please adjust your required user count to below <strong> " + paidUsers + " </strong> and then attempt the process again.");
                return;
            }

            if(usageType === 3){
                setSubTotal(subTotal + addSubTotal);
                setTotal(total + addTotal);
                setRequiredUser(parseInt(requiredUsers) + parseInt(addRequiredUsers));
            }else if(usageType === 4){
                setSubTotal(addSubTotal);
                setTotal(addTotal);
                setRequiredUser(addRequiredUsers);
            }else if(usageType === 10){
                let caluAmount = requiredUsers * pricePerUser + getAddonsAmount(requiredUsers);
                setSubTotal(caluAmount);
                setTotal(caluAmount);
            }

            const amountIncrement = (usageType === 3 || usageType === 10);
            const graterThenPaidUses = parseInt(requiredUsers) > parseInt(paidUsers);
            const isAddonsDecres = (isEarlyUpdate && subscriptiontype === "addons" && subTotal > 0 && subTotal < currentBill);
            const isPrevPayment = (isPrevPricingSub && (graterThenPaidUses || amountIncrement || !isAddonsDecres));
            if(isEarlyUpdate && (!isPrevPricingSub || isPrevPayment) && (usageType !== 8 && usageType !== 9 && usageType !== 4 && usageType !== 13)){
                if(subscriptiontype === "upgrade"){
                    setPreviosPaymentDeduction(0);
                }else if(isAddonEnbled){
                    let usersAmount = parseInt(paidUsers) * parseInt(pricePerUser);
                    let callRecAmount = parseInt(billingInfo[1]['call_rec_storage_size']) === 30 ? 0 : parseInt(paymentInfo[25]) * oldCallRecVal;
                    let whatsappAmount = parseInt(paymentInfo[25]) * whatsappApiVal;
                    let cloudAmount = parseInt(paymentInfo[26]) * cloudTeleVal;
                    setPreviosPaymentDeduction(usersAmount + callRecAmount + whatsappAmount + cloudAmount);
                }else{
                    setPreviosPaymentDeduction(parseInt(paidUsers) * parseInt(pricePerUser));
                }
            }else{
                setPreviosPaymentDeduction(0);
            }
            
            updateUsageType();

            if(isvalid){
                setCurrentStep(currentStep + 1);
            }
        }else{
            setError('To subscribe to your account, a minimum of <strong>' + paymentInfo[4] + ' Users </strong> is required. Please adjust the number of users and try again.');
        }
    }

    const checkMinimumUsers = () => {

        let isValid = false;
        if(((usageType !== 4) && parseInt(paymentInfo[4]) <= parseInt(requiredUsers)) || ((usageType === 4) && parseInt(paymentInfo[4]) <= parseInt(addRequiredUsers)) || usageType === 3){
            isValid = true;
        }

        return isValid;

    }

    const handleBackBtn = () => {
        //allow to go back only when it's not subscription update.
        if(usageType === 1 || usageType === 3 || usageType === 4 || usageType === 10 || usageType === 11){
            window.location.hash = "#/settings/account/subscription";
        }else if(usageType === 9 || usageType === 8 || !(isPricingUpdate && isRecurringPayment)){
            resetSubscriptionInfo();
            setCurrentStep(currentStep - 1);
        }
    }

    const handleUserCountChange = (count) => {
        const re = /^[0-9\b]+$/;
        if(count === '' || re.test(count)){
            let totalValAmount = (count * (pricePerUser + addOnsTotal));
            setRequiredUser(count);
            setSubTotal(totalValAmount + addOnsRecordVal);
            setTotal(totalValAmount + addOnsRecordVal);
        }
    }

    const handleAdditionalUserCountChange = (count) => {
        const re = /^[0-9\b]+$/;
        if(count === '' || re.test(count)){
            let totalValAmount = (count * (pricePerUser + addOnsTotal));
            setAddRequiredUsers(count);
            setAddSubTotal(totalValAmount + addOnsRecordVal);
            setAddTotal(totalValAmount + addOnsRecordVal);
        }
    }

    const validateTotalAmounts = (name, value) => {
        let addOnsRec = name === "additional_recordes" ? parseInt(value) : parseInt(addOnsRecordVal);
        let addOnsCallRec = name === "call_rec_storage" ? parseInt(value) : parseInt(callRecVal);
        let addOnswhatsappApi = name === "whastapp_api" ? parseInt(value) : parseInt(whatsappApiVal);
        let addonscloudTele = name === "cloud_telephony" ? parseInt(value) : parseInt(cloudTeleVal);
        let addOnsCallRecAmount = addOnsCallRec;
        let addOnswhatsappApiAmount = addOnswhatsappApi;
        let addonscloudTeleAmount = addonscloudTele;
        let totalamount = (requiredUsers * pricePerUser) + (addOnsRec) + (requiredUsers * addOnsCallRecAmount) + (requiredUsers * addOnswhatsappApiAmount) + (requiredUsers * addonscloudTeleAmount);
        setSubTotal(totalamount);
        setTotal(totalamount);
        return totalamount;
        //checkCurrentBill(requiredUsers, addOnsRec, addOnsCallRec, addOnswhatsappApi, addonscloudTele);
    }
    
    const handleAddOnsChange = (value, name) => {

        let amount = 0;
        if(name === "additional_recordes"){
            if(usageType !== 3 && usageType !== 4){
                let recordes = parseInt(value.value);
                amount = parseInt(paymentInfo[20]) * recordes / 50000;
                amount = amount * noofmonth;
                setAddOnsRecord(value);
                setAddOnsRecordVal(amount);
            }
        }else if(name === "call_rec_storage"){
            let month = value['value'] / 30;
            if(parseInt(value['value']) !== 30){
                amount = month * parseInt(paymentInfo[21]);
            }
            setCallRec(value);
            setCallRecVal(amount);
        }else if(name === "whastapp_api"){
            if(value){
                amount = parseInt(paymentInfo[22]);
            }
            amount = amount * noofmonth;
            setWhatsappApiVal(amount);
            setWhatsappApi(value);
        }else if(name === "cloud_telephony"){
            if(value){
                amount = parseInt(paymentInfo[23]);
            }
            amount = amount * noofmonth;
            setCloudTeleVal(amount);
            setCloudTele(value);
        }
        let finelAmount = validateTotalAmounts(name, amount);
        updateUsageType(isRecurringPayment, finelAmount);
        let CRS = name === "call_rec_storage" ? amount : callRecVal;
        let WAP = name === "whastapp_api" ? amount : whatsappApiVal;
        let CT = name === "cloud_telephony" ? amount : cloudTeleVal;
        setAddOnsTotal(CRS + WAP + CT);
    }

    let pricePerUser = 0;
    const currencySymbol = `₹`;
    let period = "monthly";
    let noofmonth = 1;
    if(plan === 'Quarterly'){
        period = 'quarterly';
        noofmonth = 3;
    }else if(plan === "Half Yearly"){
        period = 'halfyearly';
        noofmonth = 6;
    }else if(plan === "Annually"){
        period = 'annually';
        noofmonth = 12;
    }
    let monthAmount = 0;
    if(paymentInfo && paymentInfo.length > 0){
        if(plan === 'Monthly' && paymentInfo[17] == 'Recurring'){
            setSubscriptionType(paymentInfo[17]);
        }else{
            setSubscriptionType('Non Recurring');
            setIsEMandate(false);
        }
        if(plan === 'Monthly'){
            pricePerUser = paymentInfo[0] ? parseInt(paymentInfo[0]) : 0;
            monthAmount = pricePerUser;
        }else if(plan === 'Quarterly'){
            monthAmount = paymentInfo[1] ? parseInt(paymentInfo[1]) : 0;
            pricePerUser = monthAmount * 3;
        }else if(plan === 'Half Yearly'){
            monthAmount = paymentInfo[2] ? parseInt(paymentInfo[2]) : 0;
            pricePerUser = monthAmount * 6;
        }else if(plan === 'Annually'){
            monthAmount = paymentInfo[3] ? parseInt(paymentInfo[3]) : 0;
            pricePerUser = monthAmount * 12;
        }
    }
    const getAddonsAmount = (users) => {
        let addonsTotal = (parseInt(addOnsRecordVal)) + (callRecVal * users) + (whatsappApiVal * users) + (cloudTeleVal * users);
        return addonsTotal;
    }
    let estimatedNewBill = 0;
    if(usageType === 10 || usageType === 11){
        estimatedNewBill = requiredUsers * pricePerUser + getAddonsAmount(requiredUsers);
    }else if((usageType !== 3 && usageType !== 1) && isEarlyUpdate){
        estimatedNewBill = addSubTotal;
    }else{
        estimatedNewBill = subTotal + addSubTotal;
    }

    setTax(subTotal / 100 * 18);

    let licenseEndDate = new Date(paymentInfo[5]);
    let nextDayDateObject = new Date(licenseEndDate);
    nextDayDateObject.setDate(licenseEndDate.getDate() + 1);
    const options = { day: 'numeric', month: 'short', year: 'numeric' };
    licenseEndDate = licenseEndDate.toLocaleDateString('en-GB', options);
    nextDayDateObject = nextDayDateObject.toLocaleDateString('en-GB', options);
    let isHideLeftArrowBtn = (usageType === 1 || usageType === 3 || usageType === 4 || usageType === 10 || usageType === 11);
    let addonAmount = `${isAddonEnbled ? " + " + currencySymbol + Math.round(addOnsTotal / planMonths * 100) / 100 : ""}`;
    let paymentDesc = `${currencySymbol}${monthAmount}${addonAmount} /user/month, paid ${period}`;
    if(offerType === "Package"){
        paymentDesc = `${currencySymbol}${monthAmount * requiredUsers}${addonAmount} /month, paid ${period}`;
    }

    const isActiveEmandate = paymentDetails['method'] === "Emandate" && paymentDetails["status"] === "Active";
    return (
        <>
            <div className={`plan-page-container`}>
                <div className={`back-btn`} onClick={handleBackBtn}>
                    <i className={cx(`left-arrow-btn`,{'hide' : isHideLeftArrowBtn && false})} />
                </div>
                <div className={`plan-customization-container`}>
                    <div className={`plan-top`} >
                        {
                            error !== "" &&
                            <div className="alert alert-danger text-center pricing-error">
                                <span>{parseHtml(error)}</span>
                            </div>
                        }
                    </div>
                    <div className={`plan-details-container`}>
                        <div className={`plan-details-wrapper`}>
                            <div className={`user-customization-container`}>
                                <div className={`selected-plan-title-wrapper clearfix`}>
                                    <span className={`selected-plan-title`}>PAID {plan}</span>
                                </div>
                                
                                {
                                    paymentInfo[15] === "Customer" ? 
                                        <div> Current Active Subscription </div>
                                        : ""
                                }
                                
                                <UserRow 
                                    subLabel={paymentDesc}
                                    value={requiredUsers}
                                    onChange={handleUserCountChange}
                                    disabled={usageType === 1 || usageType === 3 || usageType === 4 || usageType === 9 || usageType === 10 || usageType === 11 || offerType === "Package" || (usageType === 13 && isEarlyUpdate && isActiveEmandate)}
                                    price={
                                        requiredUsers * pricePerUser !== '' && requiredUsers * pricePerUser > 0 ?
                                        currencyFormatter('en-IN', 'INR', ((requiredUsers * pricePerUser) + (addOnsTotal * requiredUsers))) : null
                                    }
                                    inputRef={InputRef}
                                />

                                <UserRow
                                    hidden={usageType !== 1 && usageType !== 3}
                                    title="Required Additional User"
                                    subLabel={offerType === "Package" ? `₹${pricePerUser / noofmonth} /month,  paid ${period}` : paymentDesc}
                                    value={addRequiredUsers}
                                    onChange={(val) => handleAdditionalUserCountChange(val, 'addonuser')}
                                    price={subTotal > 0 ? currencyFormatter('en-IN', 'INR', addSubTotal) : null}
                                    showGst={addRequiredUsers !== ''}
                                />

                                <UserRow
                                    hidden={usageType !== 4}
                                    title="Required User"
                                    subLabel={paymentDesc}
                                    value={addRequiredUsers}
                                    onChange={(val) => handleAdditionalUserCountChange(val, 'reduceuser')}
                                    price={subTotal > 0 ? currencyFormatter('en-IN', 'INR', addSubTotal) : null}
                                    showGst={addRequiredUsers !== ''}
                                />
                            </div>
                        </div>
                    </div>

                    <div className={cx(`plan-details-container`, {'hide' : !isAddonEnbled})}>
                        <div className={`plan-details-wrapper`}>
                            <div className={`user-customization-container`}>
                                <div className={`selected-plan-title-wrapper clearfix`}>
                                    <span className={`selected-plan-title`}>ADD-ONS</span>
                                </div>
                                <br></br>
                                <div>
                                    <div className={`user-count-selection`}>
                                        <div className={`user-count-label`}>
                                            <span>Additional Records</span><br/>
                                        </div>
                                        <div className={`user-count-add`}>
                                            <Select
                                                name="Additional Records"
                                                id="Additional Records"
                                                menuPlacement={"auto"}
                                                menuPosition={'fixed'}
                                                value={addOnsRecord}
                                                onChange={(e) => {handleAddOnsChange(e, 'additional_recordes')}}
                                                options={recordsOption}
                                                className={`basic-multi-select`}
                                                classNamePrefix="wa-select"
                                                isDisabled={usageType === 3 || usageType === 4 || usageType === 9}
                                            />
                                        </div>
                                        <div className={`user-count-price-meter`}>
                                            <div>{
                                                addOnsRecordVal !== '' &&
                                                currencyFormatter('en-IN', 'INR', addOnsRecordVal)
                                            }</div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className={`user-count-selection`}>
                                        <div className={`user-count-label`}>
                                            <span>Call Recording Storage</span><br/>
                                        </div>
                                        <div className={`user-count-add`}>
                                            <Select
                                                name="call_rec_storage"
                                                id="call_rec_storage"
                                                menuPlacement={"auto"}
                                                menuPosition={'fixed'}
                                                value={callRec}
                                                onChange={(e) => {handleAddOnsChange(e,'call_rec_storage')}}
                                                options={callRecOption}
                                                className={`basic-multi-select`}
                                                classNamePrefix="wa-select"
                                                isDisabled={usageType === 3 || usageType === 4 || usageType === 9}
                                            />
                                        </div>
                                        <div className={`user-count-price-meter`}>
                                            <div>{
                                                callRecVal !== '' &&
                                                currencyFormatter('en-IN', 'INR', callRecVal)
                                            }</div>
                                            <div className={cx({'hide' : addRequiredUsers === ''})}>+18% GST</div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className={`user-count-selection`}>
                                        <div className={`user-count-label`}>
                                            <span>WhatsApp Business API</span><br/>
                                        </div>
                                        <div className={`user-count-add`}>
                                            <div className={`notification-status`}>
                                                <Switch 
                                                    onColor={"#23ae73"} 
                                                    checked={whatsappApi} 
                                                    onChange={(e) => {handleAddOnsChange(e,'whastapp_api')}}
                                                    disabled={usageType === 3 || usageType === 4 || usageType === 9}
                                                />
                                            </div>
                                        </div>
                                        <div className={`user-count-price-meter`}>
                                            <div>{
                                                whatsappApiVal !== '' &&
                                                currencyFormatter('en-IN', 'INR', whatsappApiVal)
                                            }</div>
                                            <div className={cx({'hide' : addRequiredUsers === ''})}>+18% GST</div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className={`user-count-selection`}>
                                        <div className={`user-count-label`}>
                                            <span>Cloud Telephony</span><br/>
                                        </div>
                                        <div className={`user-count-add`}>
                                            <div className={`notification-status`}>
                                                <Switch 
                                                    onColor={"#23ae73"} 
                                                    checked={cloudTele} 
                                                    onChange={(e) => {handleAddOnsChange(e,'cloud_telephony')}}
                                                    disabled={usageType === 3 || usageType === 4 || usageType === 9}
                                                />
                                            </div>
                                        </div>
                                        <div className={`user-count-price-meter`}>
                                            <div>{
                                                cloudTeleVal !== '' &&
                                                currencyFormatter('en-IN', 'INR', cloudTeleVal)
                                            }</div>
                                            <div className={cx({'hide' : addRequiredUsers === ''})}>+18% GST</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={`plan-summary-container`}>
                        <div className={`summary-content`}>
                            <div className={`title`}>{`Summary`}</div>
                            <div className={`summary-plan-info new-sub-summary`}>
                                <div className={`subtotal-info`}>
                                    <span>{isEarlyUpdate && (usageType === 4 || usageType === 3 || usageType === 10 || usageType === 11) ? `Current estimated ` + plan + ` bill` : `Subtotal`}</span>
                                    <span className={`amount`}>
                                        {
                                            usageType === 10 || usageType === 11 ?
                                            <span className={`sub-amount`}>
                                                {currentBill ? currencyFormatter('en-IN', 'INR', currentBill, 2) : currencyFormatter('en-IN', 'INR', 0,2)}
                                            </span>
                                            : 
                                            <span className={`sub-amount`}>
                                                {subTotal ? currencyFormatter('en-IN', 'INR', subTotal, 2) : currencyFormatter('en-IN', 'INR', 0,2)}
                                            </span>
                                        }
                                        <div><span className={cx({"hide" : (usageType !== 4 && usageType !== 3)})}>+18% GST</span></div>
                                    </span>
                                </div>
                                <div className={cx(`subtotal-info hide`,{"hide" : (usageType !== 4 && usageType !== 3 && usageType !== 10 && usageType !== 11)})}>
                                    <span>Valid till {licenseEndDate}</span>
                                </div>
                            </div>
                            <div className={cx(`summary-plan-info new-sub-summary`, {'hide' : (addRequiredUsers === "" && usageType !== 10 && usageType !== 11)})}>
                                <div className={`subtotal-info line-item`}>
                                    <span>{`New estimated  ` + plan + `  bill`}</span>
                                    <span className={`amount`}>
                                        <span className={`sub-amount`}>
                                            {estimatedNewBill ? currencyFormatter('en-IN', 'INR', estimatedNewBill, 2) : currencyFormatter('en-IN', 'INR', 0,2)}
                                        </span>
                                        <div>+18% GST</div>
                                    </span>
                                </div>
                                <div className={cx(`subtotal-info hide`,{"hide" : !isEarlyUpdate && usageType !== 4})}>
                                    <span>Valid till {nextDayDateObject}</span>
                                </div>
                            </div>
                            <div className={cx(`summary-plan-info`, {"hide" : usageType === 3 || usageType === 4 || usageType === 1 || usageType === 10 || usageType === 11})}>
                                <div className={`subtotal-info line-item`}>
                                    <span>{`Tax (18%)`}</span>
                                    <span className={`amount`}>
                                        <span className={`sub-amount`}>
                                            {tax ? currencyFormatter('en-IN', 'INR', tax, 2) : currencyFormatter('en-IN', 'INR', 0,2)}
                                        </span>
                                    </span>
                                </div>
                            </div>
                            <div className={cx(`total-amount-info`, {'hide' : usageType === 3  || usageType === 4 || usageType === 1 || usageType === 10 || usageType === 11})}>
                                <span>{`Total Amount`}</span>
                                <span className={`amount`}>
                                    {subTotal && tax ? currencyFormatter('en-IN', 'INR', subTotal + tax, 2) : currencyFormatter('en-IN', 'INR', 0,2)}
                                </span>
                            </div>
                            <button className={cx(`confirm-order-btn`,{
                                'hide' : !(subTotal > 0)
                            })} onClick={handleProceed}>{(usageType !== 3 || usageType !== 4)  ? `Proceed` : `UPDATE SUBSCRIPTION`}</button>
                            <span className={cx({'hide' : !(subTotal > 0)})}>By proceeding, you agree to our <a href='https://cratiocrm.com/terms-of-service/' class="footerlink" target="_blank">terms of use</a></span>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default SubscriptionCustomize;
